
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/e-commerce",
      function () {
        return require("private-next-pages/e-commerce.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/e-commerce"])
      });
    }
  